<div class="component-container">
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <div class="page-heading text-center text-uppercase">
      {{ applicationTypeText | translate }}
      <span *ngIf="isDetailsView">- {{ 'overview.jurisdiction-overview.application_id' | translate }} {{ externalApplicationId }}</span>
    </div>
  </div>
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <div class="margin-header-align text-uppercase page-title">
      {{ 'app.navigation.doc_upload' | translate }}
    </div>
  </div>

  <div *ngIf="isLoading" class="loader-container">
    <div class="loader-overlay">
      <p-progressSpinner></p-progressSpinner>
    </div>
  </div>

  <ng-container *ngIf="!isLoading">
    <form #documentsData="ngForm" class="form-section form-font-size">
      <div class="form-font-size">
        <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
          <div class="margin-header-align section-heading">
            <div class="ui-g-12">
              <app-section-header
                [title]="'app.navigation.doc_upload' | translate | uppercase"
                [tooltip]="'tooltips.documents-submission.document-header-info' | translate"></app-section-header>
            </div>
            <div class="section-buttons">
              <lock-unlock-buttons
                [showLockButton]="isDetailsView"
                [showUnlockButton]="isDetailsView"
                [isLocked]="documentsSectionsState?.is_documents_locked"
                [formName]="DocumentFormSections.Documents"
                [areButtonsDisabled]="!(isModeratorRole() && editabilityBasedOnProcessStatus.internalRoles)"
                (lockButtonClickedEvent)="lockSection()"
                (unLockButtonClickedEvent)="unlockSection()"></lock-unlock-buttons>
              <i
                *ngIf="isDetailsView"
                class="pi pi-comment"
                [ngClass]="isDocumentsCommentVisible || documentsSectionsState?.documents_comment ? 'lock-icon-style' : 'unlock-icon-style'"
                [pTooltip]="
                  (isModeratorRole() && editabilityBasedOnProcessStatus.internalRoles) ||
                  isDocumentsCommentVisible ||
                  documentsSectionsState?.documents_comment
                    ? ('comment-section.comment-tooltip' | translate)
                    : null
                "
                [tooltipPosition]="
                  (isModeratorRole() && editabilityBasedOnProcessStatus.internalRoles) ||
                  isDocumentsCommentVisible ||
                  documentsSectionsState?.documents_comment
                    ? 'bottom'
                    : null
                "
                (click)="showComment()"></i>
            </div>
          </div>
        </div>

        <section-comment
          [isCommentTextInputVisible]="
            (role === 'employee' || role === 'administrator') && (isDocumentsCommentVisible || documentsSectionsState?.documents_comment)
          "
          [isCommentTextVisible]="role !== 'employee' && role !== 'administrator'"
          [isCommentSaveVisible]="!documentsSectionsState?.documents_comment"
          [isCommentDeleteButtonDisabled]="!editabilityBasedOnProcessStatus.internalRoles"
          [comment]="documentsSectionsState?.documents_comment"
          [formName]="DocumentFormSections.Documents"
          (saveCommentEvent)="emitUpdateComment($event.value)"
          (deleteCommentEvent)="emitUpdateComment(null)"></section-comment>

        <div *ngFor="let document of requiredDocuments; let i = index; trackBy: trackBy" class="form-background top-bottom-margin flex-row">
          <div class="ui-g-10 ui-xl-10 ui-lg-10 ui-md-10 ui-sm-10 ui-xs-10">
            <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 section-field">
              <label class="ui-g-2 field-label text-right-align required">
                {{ getDocumentLabel(document.sk_document_type) | translate }}
              </label>
              <app-file-upload
                class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-6"
                (fileDataChangeEvent)="change.emit()"
                [fileData]="document"
                [isDetailsView]="(isDetailsView && document?.filename) || isModeratorRole() || role === 'observer'"
                [isClearButtonDisabled]="isDocumentDisabled()"
                [type]="document.sk_document_type"
                [isRequired]="false"
                [inputName]="document.sk_document_type"
                (clearFileEvent)="emitClearFile($event)"></app-file-upload>
            </div>
          </div>
        </div>

        <div [ngClass]="documentsSectionsState?.is_documents_locked !== true || !isDetailsView ? '' : 'disable-section'">
          <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 mb-3">
            <div class="ui-g-12 margin-align add-button-row form-font-size" [ngClass]="isDocumentDisabled() ? 'disable-section' : ''">
              <i
                (click)="addDocument()"
                class="pi pi-plus plus-icon new-facility-plus-icon"
                id="base-data-add-facility"
                tabindex="0"
                appEnterClick></i>
              <label class="ui-g-5 field-label" for="base-data-add-facility">
                {{ 'facilities-data.form-fields.add-document-button' | translate }}
              </label>
            </div>
          </div>

          <div *ngFor="let document of otherDocuments; let i = index; trackBy: trackBy" class="form-background top-bottom-margin flex-row">
            <div class="ui-g-8 ui-xl-8 ui-lg-8 ui-md-10 ui-sm-10 ui-xs-10">
              <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12">
                <app-file-upload
                  class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-6"
                  (fileDataChangeEvent)="change.emit()"
                  [fileData]="document"
                  [inputName]="'energy_type' + i"
                  [isDetailsView]="(isDetailsView && document?.filename) || isModeratorRole() || role === 'observer'"
                  [isClearButtonDisabled]="isDocumentDisabled()"
                  [type]="documentTypes.Other"
                  [isRequired]="false"
                  (clearFileEvent)="emitClearFile($event)"></app-file-upload>
              </div>
            </div>

            <div
              class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-2 ui-sm-2 ui-xs-2 field-rows file-name-section"
              [ngClass]="isDocumentDisabled() ? 'disable-section' : ''">
              <i (click)="emitRemoveDocument(i)" class="pi pi-trash pointer-cursor delete-icon"></i>
            </div>
          </div>
        </div>

        <div>
          <app-comment-section
            [(comment)]="updateRequest.comment"
            (commentChange)="documentsData.form.markAsDirty(); change.emit()"
            [isExternalUser]="!isModeratorRole()"
            [isDetailsView]="isDetailsView"
            [orderProcess$]="commentSectionOrderProcess$"
            [editableStatuses]="commentSectionEditableStatuses"></app-comment-section>
        </div>

        <ng-container *ngIf="showContactPersonOnDocumentsPage && this.documentsData?.form">
          <app-contact-person
            [applicationId]="application_id"
            [isDetailsView]="isDetailsView"
            [data]="contactPersonData"
            (initForm)="onContactPersonInitForm($event)"
            [checkIfIsEditable]="checkIfIsEditable()"
            [forceAllowAddMessages]="isDetailsView"></app-contact-person>
        </ng-container>

        <div *ngIf="!isDetailsView && isTechnicianRole">
          <p-checkbox
            appEnterClick
            className="checkbox"
            inputId="operatorAgreement"
            name="operatorAgreement"
            [(ngModel)]="updateRequest.is_operator_agreement_confirmed"
            (ngModelChange)="change.emit()"
            binary="true"></p-checkbox>

          <label class="operatorAgreementLabel" for="operatorAgreement">{{ 'grid-comp.confirm-operator-agreement' | translate }}</label>
        </div>
      </div>
    </form>
  </ng-container>
</div>
